import { render, staticRenderFns } from "./TicketItemReports.vue?vue&type=template&id=6e74604a&"
import script from "./TicketItemReports.vue?vue&type=script&lang=js&"
export * from "./TicketItemReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports